import { CoreMenu } from '@core/types';
import moment from 'moment';

export const menu: CoreMenu[] = [
  {
    id: 'dashboard',
    title: 'Irányítópult',
    type: 'item',
    icon: 'home',
    url: 'kezdolap',
  },

  // Értékesítés
  {
    id: 'ertekesites-section',
    type: 'section',
    title: 'Értékesítés',
  },

  {
    id: 'ertekesites',
    title: 'Értékesítés',
    type: 'item',
    icon: 'shopping-cart',
    url: 'torzsek/ertekesites',
  },

  // Bizonylatok
  {
    id: 'bizonylatok',
    type: 'section',
    title: 'Bizonylatok',
  },
  {
    id: 'penzugyi-bizonylatok',
    title: 'Bizonylatok',
    type: 'collapsible',
    icon: 'credit-card',
    children: [
      {
        id: 'ajanlat',
        title: 'Árajánlat',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/ajanlat',
      },
      {
        id: 'bejovo-szamla',
        title: 'Bejövő számla',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/bejovo-szamla',
      },
      {
        id: 'bevetelezes',
        title: 'Bejövő szállítólevél',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/bevetelezes',
      },
      {
        id: 'dijbekero',
        title: 'Díjbekérő',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/dijbekero',
      },
      {
        id: 'elolegszamla',
        title: 'Előlegszámla',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/elolegszamla',
      },
      // {
      //   id: 'foglalas',
      //   title: 'Foglalás',
      //   type: 'item',
      //   icon: 'codesandbox',
      //   url: 'torzsek/foglalas',
      // },
      {
        id: 'kimenoszamla',
        title: 'Kimenő számla',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/kimeno-szamla',
      },
      // {
      //   id: 'kulsoraktarieladas',
      //   title: 'Külső raktári eladás',
      //   type: 'item',
      //   icon: 'codesandbox',
      //   url: 'torzsek/kulso-raktari-eladas',
      // },
      {
        id: 'nyugta',
        title: 'Nyugta',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/nyugta',
      },
      {
        id: 'penztar',
        title: 'Pénztár',
        type: 'item',
        icon: 'codesandbox',
        url: `torzsek/penztar/${moment().format('YYYY-MM-DD')}/${moment().format('YYYY-MM-DD')}`,
      },
      {
        id: 'szallitolevel',
        title: 'Szállítólevél',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/szallitolevel',
      },
      {
        id: 'utalasi-jegyzek',
        title: 'Utalási jegyzék',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/utalasi-jegyzek',
      },
    ],
  },
    {
    id: 'keszletkezeles',
    title: 'Készletkezelés',
    type: 'collapsible',
    icon: 'list',
    children: [
      {
        id: 'beszerzes-visszaigazolas',
        title: 'Beszerzés visszaigazolás',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/beszerzes-visszaigazolas',
      },
      {
        id: 'cikkarazas',
        title: 'Cikk árazás',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/cikkarazas',
      },
      {
        id: 'egyeb-raktari-bevet',
        title: 'Egyéb raktári bevét',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/egyeb-raktari-bevet',
      },
      {
        id: 'egyeb-raktari-kivet',
        title: 'Egyéb raktári kivét',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/egyeb-raktari-kivet',
      },
      {
        id: 'leltar',
        title: 'Leltár',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/leltar',
      },
      {
        id: 'raklapkezeles',
        title: 'Raklapkezelés',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/raklapkezeles',
      },
      {
        id: 'raktarkeszlet',
        title: 'Raktárkészlet',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/raktarkeszlet',
      },
    ],
  },

  // Koordinátor
  {
    id: 'koordinator',
    type: 'section',
    title: 'Koordinátor',
    icon: 'box',
  },
  {
    id: 'analitika',
    title: 'Analitika',
    type: 'item',
    icon: 'bar-chart',
    url: 'torzsek/analitika',
  },
  {
    id: 'cegadatok-collapsible',
    title: 'Cégadatok',
    type: 'collapsible',
    icon: 'book',
    children: [
      {
        id: 'bizonylattipusok',
        title: 'Bizonylattípusok',
        type: 'item',
        icon: 'edit-3',
        url: 'torzsek/bizonylattipusok',
      },
      {
        id: 'onelszamoloegysegek',
        title: 'Cégek',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/onelszamoloegysegek',
      },
      {
        id: 'feladat-kategoriak',
        title: 'Feladat kategóriák',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/feladat-kategoriak',
      },
      {
        id: 'naptar-kategoriak',
        title: 'Naptár kategóriák',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/naptar-kategoriak',
      },
    ],
  },
  {
    id: 'cikk-csoportositas',
    title: 'Cikk csoportosítás',
    type: 'item',
    icon: 'file-text',
    url: 'torzsek/cikk-csoportositas',
  },
  {
    id: 'cikkcsoportok',
    title: 'Cikkcsoportok',
    type: 'item',
    icon: 'file-text',
    url: 'torzsek/cikkcsoportok',
  },
  {
    id: 'cikktorzs',
    title: 'Cikktörzs',
    type: 'item',
    icon: 'file-text',
    url: 'torzsek/cikktorzs',
  },
    {
    id: 'cim-adatok',
    title: 'Cím adatok',
    type: 'collapsible',
    icon: 'book-open',
    children: [
      {
        id: 'cimtipusok',
        title: 'Címtípusok',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/cimtipusok',
      },
      {
        id: 'megyek',
        title: 'Megyék',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/megyek',
      },
      {
        id: 'nyelvek',
        title: 'Nyelvek',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/nyelvek',
      },
      {
        id: 'orszagok',
        title: 'Országok',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/orszagok',
      },
      {
        id: 'telepulesek',
        title: 'Települések',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/telepulesek',
      },
    ],
  },
  {
    id: 'dolgozoi-adatok',
    title: 'Dolgozói adatok',
    type: 'collapsible',
    icon: 'briefcase',
    children: [
      {
        id: 'beosztasok',
        title: 'Beosztások',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/beosztasok',
      },
      {
        id: 'dolgozok',
        title: 'Dolgozók',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/dolgozok',
      },
      {
        id: 'egeszsegugyiadatok',
        title: 'Egészségügyi adatok',
        type: 'item',
        icon: 'heart',
        url: 'torzsek/egeszsegugyiadatok',
      },
      {
        id: 'eltartottminoseg',
        title: 'Eltartotti minőségek',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/eltartottminoseg',
      },
      {
        id: 'feor',
        title: 'FEOR',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/feor',
      },
      {
        id: 'felhasznaloicsoportok',
        title: 'Felhasználói csoportok',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/felhasznaloicsoportok',
      },
      {
        id: 'foglalkoztatas-jellege',
        title: 'Foglalkoztatás jellegei',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/foglalkoztatas-jellege',
      },
      {
        id: 'igenybevett-kedvezmeny',
        title: 'Igénybe vett kedv.',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/igenybevett-kedvezmeny',
      },
      {
        id: 'iskolaivegzettsegek',
        title: 'Iskolai végzettségek',
        type: 'item',
        icon: 'award',
        url: 'torzsek/iskolaivegzettsegek',
      },
      {
        id: 'jogositvanykategoriak',
        title: 'Jogositvány kategóriák',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/jogositvanykategoriak',
      },
      {
        id: 'jogviszony',
        title: 'Jogviszonyok',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/jogviszony',
      },
      {
        id: 'jogosultsag-jogcimek',
        title: 'Jogosultság jogcímek',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/jogosultsag-jogcimek',
      },
      {
        id: 'megszunesmodja',
        title: 'Megszűnés módjai',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/megszunesmodja',
      },
      {
        id: 'munkarend',
        title: 'Munkarend',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/munkarend',
      },
      {
        id: 'munkanapok',
        title: 'Munkanapok',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/munkanapok',
      },
      {
        id: 'munkaviszonytipusa',
        title: 'Munkaviszony típusai',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/munkaviszonytipusa',
      },
      {
        id: 'szervezeti-egysegek',
        title: 'Szervezeti egységek',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/szervezeti-egysegek',
      },
      {
        id: 'szabadsagtipusok',
        title: 'Szabadság típusok',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/szabadsagtipusok',
      },
    ],
  },
  {
    id: 'hr-analitika',
    title: 'HR analitika',
    type: 'item',
    icon: 'bar-chart',
    url: 'torzsek/hr-analitika',
  },
  {
    id: 'keszlet',
    title: 'Készlet adatok',
    type: 'collapsible',
    icon: 'list',
    children: [
      {
        id: 'mennyisegiegysegek',
        title: 'Mennyiségi egységek',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/mennyisegiegysegek',
      },
      {
        id: 'raktarak',
        title: 'Raktárak',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/raktarak',
      },
    ],
  },
  {
    id: 'munkatarsak',
    title: 'Munkatársak',
    type: 'item',
    icon: 'user',
    url: 'torzsek/munkatarsak',
  },
  {
    id: 'nyomtatvanyok',
    title: 'Nyomtatványok',
    type: 'item',
    icon: 'file-text',
    url: 'torzsek/nyomtatvanyok',
  },
  {
    id: 'partnerek',
    title: 'Partnerek',
    type: 'item',
    icon: 'users',
    url: 'torzsek/partnerek',
  },

  {
    id: 'penzugyi-adatok',
    title: 'Pénzügyi adatok',
    type: 'collapsible',
    icon: 'credit-card',
    children: [
      {
        id: 'afakulcsok',
        title: 'Áfakulcsok',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/afakulcsok',
      },
      {
        id: 'arkategoriak',
        title: 'Árkategóriák',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/arkategoriak',
      },
      {
        id: 'arfolyamok',
        title: 'Árfolyamok',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/arfolyamok',
      },
      {
        id: 'bevetel-kategoriak',
        title: 'Bevétel kategóriák',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/bevetel-kategoriak',
      },
      {
        id: 'fizetesimodok',
        title: 'Fizetési módok',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/fizetesimodok',
      },
      {
        id: 'fokonyviszamok',
        title: 'Főkönyvi számok',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/fokonyviszamok',
      },
      {
        id: 'ki-be-fizetesi-jogcimek',
        title: 'Ki-be fizetési jogcímek',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/ki-be-fizetesi-jogcimek',
      },
      {
        id: 'kintlevosegek',
        title: 'Kintlévőségek',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/kintlevosegek',
      },
      {
        id: 'konyveloi',
        title: 'Könyvelői export',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/konyveloi',
      },
      {
        id: 'koltseg-kategoriak',
        title: 'Költség kategóriák',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/koltseg-kategoriak',
      },
      {
        id: 'koltseg-helyek',
        title: 'Költség helyek',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/koltseg-helyek',
      },
      {
        id: 'nyugdijkodok',
        title: 'Nyugdíjkódok',
        type: 'item',
        icon: 'align-justify',
        url: 'torzsek/nyugdijkodok',
      },
      {
        id: 'penzintezetek',
        title: 'Pénzintézetek',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/penzintezetek',
      },
      {
        id: 'penznemek',
        title: 'Pénznemek',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/penznemek',
      },
      {
        id: 'penztarak',
        title: 'Pénztárak',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/penztarak',
      },
      {
        id: 'szamlazas-gyakorisag',
        title: 'Számlázás gyakoriság',
        type: 'item',
        icon: 'codesandbox',
        url: 'torzsek/szamlazas-gyakorisag',
      },
    ],
  },
];
